import axios from "axios";
import { Notification } from 'element-ui';
// import store from '../store'
const request = axios.create({
    baseURL: 'https://www.sjxsm.com/uniform/',
    // baseURL: 'http://192.168.1.174:9000/',
    timeout: 20000
})
//console.log('store',store.state);
//请求拦截器
request.interceptors.request.use(function (config) {
    // //console.log('11111111', config);
    let authorization = '';
    authorization = sessionStorage.getItem('authorization')
    // console.log(authorization);
    if (authorization) {
        // console.log(111);
        config.headers.authorization = 'Bearer ' + authorization
    }
    return config;
}, function (error) {
    return Promise.reject(error)
})

//响应拦截器
request.interceptors.response.use(function (response) {
    const code = response.data.code || '200';
    // //console.log('响应',response);
    // console.log(code === '401' || code === '403');
    if (response.status === 200 && (code != '401' && code != '403')) {
        // //console.log('response',response.data);

        return Promise.resolve(response.data);
    } else if (code === '401' || code === '403') {
        // //console.log(code);
        // notify({
        //     title: '13212',
        //     type: 'error'
        // });
        Notification({
            message: response.data.message,
            type: 'error'
        })
        setTimeout(() => {
            // window.location.replace(null)
            sessionStorage.removeItem('token')
            location.href = '/'
        }, 1000)
        return Promise.resolve(response.data);
    } else {
      //console.log(2);
        Promise.reject(response)
    }
}, function (error) {
    return Promise.reject(error)
})

export default request